import React, { useCallback } from 'react'
import { useHistory } from 'react-router'
import { returnType } from '../../../../../OrderHistory/components/buttons/manageButtonType'
import { RmaDetailLRButtonContainer } from './style/Button.css'

const DetailButton = ({
  submitForm,
  orderDetails,
}) => {
  const { order_id: orderId } = { ...orderDetails }
  const history = useHistory()
  const cancelReturn = useCallback(() => {
    history.push(`/myaccount/orderdetails?orderId=${orderId}&returnType=${returnType.lifetime}`)
  }, [history, orderId])

  return (
    <RmaDetailLRButtonContainer>
      <p>
        Once a return request has been submitted,
        it cannot be edited or cancelled.
        Please double-check that everything is entered correctly.
      </p>
      <p>
        By clicking “Submit Claim”,
        I confirm that I have already purchased an identical part
        from CarParts.com to
        replace my original order.
      </p>
      <button
        type="button"
        onClick={submitForm}
      >
        Submit Claim
      </button>
      <button type="button" onClick={cancelReturn}>
        Cancel Lifetime Replacement Claim
      </button>
    </RmaDetailLRButtonContainer>
  )
}

export default DetailButton
